import { addStyles } from 'ethcss'
import grid from 'blocks.simple/grid/grid.jcss'
import item from 'blocks.simple/item/item.jcss'
import { radiusSizes, mediaCSS, color, palette } from 'theme'
import { defaultThemeStyles as defaultThemeAppStyles } from 'blocks.app/app/app.theme.jcss'
import { defaultThemeStyles } from './DisplayInfo-theme'
import 'blocks.app/loader/loader.css'
import { colors, IStyles } from '../../../theme'
import { defaultThemeStyles as defaultThemeSidebarStyles } from '../../../blocks.app/sidebar/Sidebar-theme'

const displaysInfoStyles: IStyles = {
    mainWrapper: {
        position: 'relative',
        padding: 24,
        width: '100%',
        minHeight: '100%',
        overflow: 'visible',
        backgroundColor: color.bgWhiteSecondary,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        height: 'auto',
        [mediaCSS.tab]: {
            padding: 12,
        },
    },
    wrapperContainer: {
        position: 'relative',
        width: '100%',
        maxWidth: 1440,
        borderRadius: 16,
        boxSizing: 'border-box',

        [mediaCSS.desktopML]: {
            maxWidth: 1280,
            padding: '24px 20px',
        },
        [mediaCSS.desktopL]: {
            maxWidth: 960,
            padding: '24px 20px',
        },
        [mediaCSS.tab]: {
            padding: '20px 12px',
            borderRadius: 12,
        },
    },
    backButton: {
        display: 'flex',
        alignItems: 'center',
        position: 'absolute',
        left: 30,
        top: 32,
        fontSize: 16,
        cursor: 'pointer',

        span: {
            marginLeft: 10,

            [mediaCSS.tab]: {
                display: 'none',
                top: 26,
            },
        },

        [mediaCSS.tab]: {
            left: 12,
            top: 20,
        },
    },
    title: {
        fontSize: 24,
        maxWidth: 900,
        margin: '0 auto 40px auto',
        textAlign: 'center',

        [mediaCSS.desktopML]: {
            maxWidth: 700,
        },

        [mediaCSS.desktopL]: {
            maxWidth: 500,
            padding: '0 50px',
        },

        [mediaCSS.tab]: {
            maxWidth: '100%',
            padding: '0 50px',
            fontSize: 14,
        },
    },
    titleSeparator: {
        color: colors.grey,
    },
    titleName: {
        color: colors.blueAccent,
        fontWeight: 600,
    },
    wrapper: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        gap: 20,

        [mediaCSS.desktopL]: {
            flexWrap: 'wrap',
        },
    },
    leftBlock: {
        width: 650,
        flexShrink: 0,

        [mediaCSS.desktopL]: {
            width: '100%',
            marginBottom: 12,
        },
    },
    screenshotWrapper: {
        padding: 10,
        borderRadius: 12,
        border: `1px solid ${color.borderDarkPrimary}`,
        backgroundColor: colors.white,
    },
    screenshot: {
        height: 354,
        borderRadius: 8,
        background: colors.black,
        overflow: 'hidden',
        marginBottom: 10,
    },
    screenshotInner: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        padding: 8,
    },
    statusName: {
        display: 'inline-block',
        color: colors.white,
        borderRadius: 4,
        padding: 6,
    },
    rightBlock: {
        flex: 1,
        minWidth: 0,
        width: 'auto',
        backgroundColor: 'transparent',
        borderRadius: 12,
        overflow: 'visible',

        [mediaCSS.desktopL]: {
            width: '100%',
        },
    },
    dsControlPanel: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: 6,
    },
    controlButton: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: 42,
        height: 42,
        border: `1px solid ${colors.cloud}`,
        borderRadius: 8,
        marginRight: 0,
        backgroundColor: colors.white,
        opacity: 0.9,
        transition: 'all 0.3s',
        cursor: 'pointer',

        [mediaCSS.tab]: {
            marginTop: 8,
        },

        '&:hover': {
            boxShadow: '0px 2px 0px 0px rgba(0, 0, 0, 0.15)',
            opacity: 1,
        },

        '&:focus': {
            opacity: 1,
        },
    },
    dsStatusBlock: {
        borderRadius: 12,
        marginTop: 12,
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
    },
    statusTopRow: {
        display: 'flex',
        alignItems: 'stretch',
        gap: 10,
        width: '100%',

        [mediaCSS.tab]: {
            flexWrap: 'wrap',
        },
    },
    statusGrid: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: 10,
        width: '100%',

        [mediaCSS.tab]: {
            gridTemplateColumns: '1fr',
        },
    },
    statusBlock: {
        background: colors.white,
        borderRadius: 8,
        padding: 8,
        border: `1px solid ${color.borderDarkPrimary}`,
        flex: 1,
        minWidth: 0,
    },
    statusBlockLabel: {
        marginBottom: 8,
        color: colors.grey,
        fontSize: 12,
    },
    statusBlockValue: {
        color: colors.black,
        fontWeight: 600,
        fontSize: 14,
        wordBreak: 'break-word',
    },
    headerPanel: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 10,
    },
    toggleButtons: {
        display: 'flex',
    },
    toggleViewButton: {
        display: 'inline-flex',
        alignItems: 'center',
        padding: '8px 12px',
        border: `1px solid ${color.borderDarkPrimary} !important`,
        borderRadius: 8,
        cursor: 'pointer',
        backgroundColor: `${colors.white} !important`,
        color: colors.blackLight,
        boxShadow: 'none',

        span: {
            marginLeft: 8,

            [mediaCSS.tab]: {
                display: 'none',
            },
        },

        transition: 'all 0.3s',

        '&:hover': {
            borderColor: `${color.borderDarkSecondary} !important`,
        },
    },
    collapseCard: {
        marginBottom: 10,
        backgroundColor: colors.white,
        borderRadius: 12,
        border: `1px solid ${color.borderDarkPrimary}`,
        overflow: 'hidden',
        boxShadow: 'none',
        padding: 0,
    },
    collapseContent: {
        padding: '0 8px',
    },
    dropContent: {
        background: colors.white,
        borderRadius: 5,
        overflow: 'hidden',
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    },
    params: {
        ...grid.w50,
        ...grid.col,
        ...grid.pl_mdPlus,
        ...grid.fullHeight,
        position: 'relative',
        [mediaCSS.tab]: {
            ...grid.w100,
            ...grid.row,
            height: 'auto',
            ...grid.pl_none,
            ...grid.pb_md,
            ...grid.mt_mdPlus,
        },
    },
    iconUpdate: {
        backgroundColor: colors.white,
        borderRadius: 8,
        padding: 4,

        opacity: 0.7,
        transition: 'all 0.3s',
        cursor: 'pointer',

        '&:hover': {
            boxShadow: '0px 2px 0px 0px rgba(0, 0, 0, 0.15)',
            opacity: 1,
        },

        '&:focus': {
            opacity: 1,
        },
    },
    iconUpdateAnim: {
        animation: `loaderSpinAnimation 0.8s linear infinite`,
    },

    image: {
        boxShadow: '0px 3px 13.5px 1.5px rgba(0, 0, 0, 0.5)',
    },
    imageContent: {
        backgroundColor: `var(--var-module-device-component-info-style-imageContent, ${defaultThemeStyles.imageContent})`,
    },
    buttons: {
        ...grid.p_md,
        ...grid.row,
        ...grid.normalCenter,
        ...grid.justify,
        position: 'relative',
        borderRadius: `${radiusSizes.mini}px`,
    },
    offline: {
        backgroundColor: `var(--var-module-app-component-app-style-offline, ${defaultThemeAppStyles.offline})`,
    },
    ping: {
        backgroundColor: `var(--var-module-app-component-app-style-ping, ${defaultThemeAppStyles.ping})`,
    },
    error: {
        backgroundColor: `var(--var-module-app-component-app-style-error, ${defaultThemeAppStyles.error})`,
    },
    online: {
        backgroundColor: `var(--var-module-app-component-app-style-online, ${defaultThemeAppStyles.online})`,
    },
    sleep: {
        backgroundColor: `var(--var-module-app-component-app-style-sleep, ${defaultThemeAppStyles.sleep})`,
    },
    online_display_off: {
        backgroundColor: `var(--var-module-app-component-app-style-online-display-off, ${defaultThemeAppStyles.displayOff})`,
        backgroundSize: 'cover',
    },
    displayOffDiv: {
        color: colors.white,
    },
    icons: {
        ...grid.row,
        [mediaCSS.tab]: {
            ...grid.center,
        },
    },
    iconWrapperPb: {
        [mediaCSS.tabMini]: {
            ...grid.pb_mini,
        },
    },
    paramsList: {
        ...grid.row,
        padding: 0,
        overflow: 'visible',
        '& .displaysInfo__paramsItem:last-child': {
            border: 'none',
        },
        height: 'auto',
        maxHeight: 'none',

        [mediaCSS.tab]: {
            width: '100%',
        },
    },
    paramsItem: {
        ...grid.p_micro,
        ...grid.row,
        ...grid.fullWidth,
        alignItems: 'center',
        borderBottom: `1px solid ${colors.cloud}`,
    },
    paramsItemTop: {
        alignItems: 'flex-start',
    },
    displayParameterName: {
        color: colors.grey,
        lineHeight: '22px',
        paddingRight: '10px',
    },
    paramLabelRow: {
        display: 'inline-flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 6,
    },
    fieldHintBadge: {
        display: 'inline-flex',
        alignItems: 'center',
        padding: '1px 6px',
        borderRadius: 4,
        backgroundColor: colors.cloud,
        color: colors.grey,
        fontSize: 11,
        lineHeight: '16px',
        fontWeight: 400,
        textTransform: 'none',
        letterSpacing: 'normal',
        whiteSpace: 'nowrap',
    },
    fieldDescription: {
        marginTop: 6,
        color: colors.grey,
        fontSize: 12,
        lineHeight: '16px',
        fontWeight: 400,
        cursor: 'default',
    },
    paramLink: {
        color: colors.blueAccent,
        textDecoration: 'none',
        wordBreak: 'break-all',

        '&:hover': {
            textDecoration: 'underline',
        },
    },
    headerCaptionAccent: {
        color: colors.blueAccent,
        textTransform: 'none',
        letterSpacing: 'normal',
        fontWeight: 500,
    },
    logLevelValue: {
        color: colors.blueAccent,
        cursor: 'pointer',
    },
    tagList: {
        ...grid.mb_mini,
        ...grid.colCenter,
        overflowY: 'auto',
        [mediaCSS.tab]: {
            ...grid.mb_none,
        },
    },
    topInfo: {
        height: '20%',
        ...grid.row,
        ...grid.space,
        ...grid.pt_big,
        [mediaCSS.tab]: {
            height: 'auto',
        },
    },
    tagWrapper: {
        ...grid.pt_mini,
        ...grid.fullWidth,
        ...grid.pb_mini,
    },
    tagItem: {
        ...grid.mr_mini,
        ...grid.mb_mini,
    },
    minWidthLicenseDropdown: {
        minWidth: '180px',
    },
    dataScreenshot: {
        position: 'absolute',
        bottom: 0,
    },
    getLogsBtn: {
        backgroundColor: `var(--var-module-device-component-info-style-button, ${defaultThemeStyles.button})`,
    },

    modalAccept: {
        backgroundColor: `var(--var-module-device-component-info-style-modalAccept, ${defaultThemeStyles.modalAccept})`,
    },
    copyToBufferIconWrapper: {
        position: 'absolute',
        top: -grid.mb_mdPlus['margin-bottom'],
        right: 0,

        [mediaCSS.tab]: {
            right: 10,
            top: 6,
            zIndex: 1,
        },
    },
    displayInfoParameterValue: {
        ...grid.w55,
        wordWrap: 'break-word',
        cursor: 'copy',
    },
    groupList: {
        position: 'relative',
        overflow: 'hidden',
    },
    groupHeader: {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        height: '34px',
        padding: '0 4px',
        letterSpacing: '0.1em',
        justifyContent: 'space-between',
        width: 'calc(100% - 20px)',
    },
    groupHeaderItem: {
        display: 'flex',
        alignItems: 'center',
        height: '34px',
        letterSpacing: '0.1em',
    },
    subHeader: {
        height: 'fit-content',
        color: '#fff',
        backgroundColor: 'rgb(78, 155, 234)',
        padding: '8px',
    },
    subHeaderError: {
        height: 'fit-content',
        color: '#fff',
        backgroundColor: `var(--var-module-app-component-app-style-error, ${defaultThemeAppStyles.error})`,
        padding: '8px',
    },
    headerCaption: {
        marginLeft: '12px',
        textTransform: 'capitalize',
    },
    headerActive: {
        display: 'inline-block',
        cursor: 'pointer',
        padding: '2px 6px',
        borderRadius: 4,
        backgroundColor: colors.water,
        color: colors.darkBlue,
        marginBottom: 8,
    },
    scroll: {
        width: '100%',
        height: 'auto',
        overflow: 'visible',
        backgroundColor: color.bgWhiteSecondary,
    },
    checkConnectionBtn: {
        position: 'absolute',
        top: '50%',
        right: '10px',
        transform: 'translateY(-50%)',
        fontWeight: '500',
        textDecoration: 'underline',
        textTransform: 'none',
        cursor: 'pointer',

        '&:hover': {
            textDecoration: 'none',
        },
    },
    logLevelInfo: {
        margin: '10px 0',
        maxWidth: '470px',
    },
    waitForDownload: {
        margin: '10px 0',
        maxWidth: '470px',
    },
    goToSettings: {
        textDecoration: 'underline',

        '&:hover': {
            textDecoration: 'none',
            cursor: 'pointer',
        },
    },
    clearInfoClass: {
        maxWidth: 800,

        [mediaCSS.desktop]: {
            maxWidth: 540,
        },

        [mediaCSS.tabMini]: {
            maxWidth: 360,
        },
    },
    webEngineModal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'fixed',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        zIndex: 9999,
        backgroundColor: 'rgba(0,0,0,0.7)',
    },
    webEngineModalInner: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        minWidth: '30%',
        backgroundColor: colors.white,
        borderRadius: '20px',
        padding: '20px 20px 100px 20px',
        textAlign: 'center',
    },
    webEngineModalClose: {
        position: 'absolute',
        top: 20,
        right: 20,
    },
    webEngineInfoCaption: {
        fontSize: 20,
        fontWeight: 600,
        marginBottom: 70,
    },
    wikiLink: {
        '>div': {
            display: 'flex',
            alignItems: 'center',
        },
        span: {
            fontSize: 11,
            marginLeft: 24,
        },
        a: {
            color: colors.blueAccent,
        },
    },
    showMore: {
        paddingLeft: 8,
        textDecoration: 'underline',
        margin: '4px 0 6px 0',
        cursor: 'pointer',

        '&:hover': {
            textDecoration: 'none',
        },
    },
    powerControls: {
        width: 'auto !important',
    },
    powerBtn: {
        //marginRight: 6,
    },
    contentClassName: {
        width: 200,
        textAlign: 'center',
        borderRadius: '5px',
    },
    menuItem: {
        ...grid.row,
        ...grid.normalCenter,
        ...grid.center,
        ...grid.p_mini,
        ...item.pointer,
        ...item.relative,
        textAlign: 'center',
        ...item.transitionErase,
        ...item.pointer,
        color: `var(--var-module-sidebar-component-sidebar-style-menuTextHover, ${defaultThemeSidebarStyles.menuTextHover})`,
        '&:hover': {
            color: `var(--var-module-sidebar-component-sidebar-style-menuText, ${defaultThemeSidebarStyles.menuText})`,
        },
    },
    groupPlaceholder: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: 72,
        padding: '16px 0',
    },
    sectionLoaderSpinner: {
        width: 14,
        height: 14,
        borderRadius: '50%',
        border: `2px solid ${palette.neutral[200]}`,
        borderTopColor: colors.blueAccent,
        animation: 'loaderSpinAnimation 0.8s linear infinite',
        boxSizing: 'border-box',
        flexShrink: 0,
    },
    sectionLoaderSpinnerSm: {
        width: 14,
        height: 14,
        borderRadius: '50%',
        border: `2px solid ${palette.neutral[200]}`,
        borderTopColor: colors.white,
        animation: 'loaderSpinAnimation 0.8s linear infinite',
        flexShrink: 0,
        boxSizing: 'border-box',
    },
    loadingConnectionRow: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
    },
    iconGroupWrapper: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        gap: 8,
    },
    rightBtn: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: 40,
        height: 40,
        borderRadius: 10,
        border: '1px solid #D9D9D9',
        backgroundColor: colors.white,
        cursor: 'pointer',
        boxSizing: 'border-box',
        transition: 'border-color 0.2s',

        '&:hover': {
            borderColor: '#BFBFBF',
        },
    },
    softResetModal: {
        position: 'fixed',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        backgroundColor: 'rgba(0,0,0,0.7)',
        zIndex: 2000,
    },
    softResetModalInner: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: colors.white,
        borderRadius: 20,
        padding: 30,
        maxWidth: 384,
    },
    softResetModalCaption: {
        textTransform: 'uppercase',
        textAlign: 'center',
        marginBottom: 20,
    },
    softResetModalButtons: {
        display: 'flex',
        justifyContent: 'center',
    },
    softResetModalButton: {
        display: 'flex',
        justifyContent: 'center',
        margin: '0 10px',
        minWidth: 100,
    },
    groupTreeTable: {
        width: '100%',
        textAlign: 'left',
        border: `1px solid ${colors.greyLight}`,
    },
    groupTreeRow: {
        borderTop: `1px solid ${colors.greyLight}`,
    },
    groupTreeCol: {
        padding: 8,
    },
    groupTreeColName: {
        paddingLeft: 28,
        position: 'relative',
    },
    toggleGroupButton: {
        position: 'absolute',
        top: 8,
        left: 8,
    },
    dot: {
        position: 'absolute',
        top: 8,
        marginRight: 8,
        color: colors.grey,
    },
    paramsItemTextOverflow: {
        overflowWrap: 'break-word',
    },
    countdown: {
        marginLeft: 10,
    },
    confirmModal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'fixed',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        zIndex: 10000,
        backgroundColor: 'rgba(0,0,0,0.7)',
    },
    confirmModalInner: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 320,
        backgroundColor: colors.white,
        borderRadius: '20px',
        padding: '20px',
        textAlign: 'center',
    },
    confirmModalButtons: {
        display: 'flex',
        justifyContent: 'center',
    },
    confirmModalButton: {
        margin: '0 14px',
    },
    confirmModalText: {
        textAlign: 'center',
        marginBottom: 20,
    },
}

addStyles(displaysInfoStyles)
export default displaysInfoStyles
